import React, { Component } from "react";
import Button from "../../components/bases/button/button";
import { GlobalContext } from "../../utils/globalprovider.js";
import imgClose from "./assets/close.png"

import imgBack from "./assets/back.png"
import imgValider from "./assets/valider.png"


import FullscreenOverlay from "./fullscreenoverlay.js";

import "./dialog.css"

class Dialog extends Component {

  static contextType = GlobalContext;
  constructor(props) {
    super(props);


    

    this.state = {
      isDragging: false, // Indique si on est en train de drag
      offsetX: 0, // Décalage horizontal entre la souris et la div
      offsetY: 0, // Décalage vertical entre la souris et la div
      x: 0, // Position initiale horizontale
      y: 0, // Position initiale verticale
      displayme: "hidden",
      tabIndex: 0,
    };
    // Liaison des méthodes
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);

    

    this.fulldiv = this.generateUUID();
    this.innerdiv = this.generateUUID();
    this.cancelKey = false;

    this.onresizeForm = this.onresizeForm.bind(this)

    this.setCancelKeyDialog = this.setCancelKeyDialog.bind(this);
  }

setCancelKeyDialog(value)
{
  this.cancelKey = value;
}

componentWillUnmount()
{
  
}

 onresizeForm()
 {
      
      
    
      var innerdiv = document.getElementById(this.innerdiv);
      if (!innerdiv) 
      {
        return;
      }
      
      const rect = innerdiv.getBoundingClientRect();
      if (rect.width === 0) return;
      
      
      
      var x = window.innerWidth/2 - rect.width/2;
      var y = window.innerHeight/2 - rect.height/2;       

      if (this.props.startposition === "right")
        x = window.innerWidth - rect.width - 100;
      
      this.setState({
        x:x,
        y:y,
        tabIndex:1,
        tobecenter:false,
        displayme: "visible",
      }) 
  
      

 }

 onQuit()
 {

    
 }

  onValid()
  {

  }



  
  
  componentDidUpdate()
  {
    
     if (this.props.display)
     {
      if (this.state.tobecenter)
      {

        
      }
     }
  }

  handleKeyDown(e)
  {

    
    if (this.cancelKey) return;
      
      
      if (e.code ==="Escape")
      {
        e.preventDefault();
        e.stopPropagation();
        this.onQuit();
        return;
      }

      if (e.key === "Enter")
      {
       
        if (this.isButtonOkValid())
        {
          e.preventDefault();
          e.stopPropagation();
          this.onValid();
          return;
        }
        else
          console.log("pas de bouton enter")
      }
      e.stopPropagation();
  }
  generateUUID() 
  {
    const array = new Uint8Array(16);
    window.crypto.getRandomValues(array);

    array[6] = (array[6] & 0x0f) | 0x40; // Version 4
    array[8] = (array[8] & 0x3f) | 0x80; // Variant 1

    return [...array].map((byte, index) => {
        const hex = byte.toString(16).padStart(2, '0');
        return ([4, 6, 8, 10].includes(index) ? '-' : '') + hex;
    }).join('');
}


  handleMouseDown(event) {
    // Enregistre l'état de dragging et l'offset
    console.log("dialog mouse down", this.state.title.fr)
    this.setState({
      isDragging: true,
      offsetX: event.clientX - this.state.x,
      offsetY: event.clientY - this.state.y,
    });

    window.addEventListener("mouseup", this.handleMouseUp);
    window.addEventListener("mousemove", this.handleMouseMove);


  }

  handleMouseMove(event) {
    // Si on est en train de drag, mettre à jour la position
    console.log("mouse move ", this.state.isDragging, this.state.title.fr)
    if (this.state.isDragging) {

      var innerdiv = document.getElementById(this.innerdiv);
      const rect = innerdiv.getBoundingClientRect();
      const maxx = window.innerWidth - rect.width- 80;
      const maxy = window.innerHeight - rect.height - 50;



      var x = event.clientX - this.state.offsetX;
      var y = event.clientY - this.state.offsetY;

      if ( x > maxx) x = maxx;
      if ( y > maxy) y = maxy;

      if ( x <30) x=30;
      if ( y < 100) y=100;

      
      
      this.setState({
        x: x,
        y: y,
      });

    }
  }

  handleMouseUp() {
    // Arrêter le dragging
    this.setState({ isDragging: false });
    window.removeEventListener("mouseup", this.handleMouseUp);
    window.removeEventListener("mousemove", this.handleMouseMove);
  }

  componentDidMount() {
   
    setTimeout(() => {

      
      this.onresizeForm();
    }, 20);


    // Ajout des écouteurs globaux pour le déplacement et le relâchement
  }


  setDisabledButtonByType(type, value)
  {
      var buttons = this.state.buttons;
      var nb = buttons.length;
      for (var i=0; i < nb ; i++)
      {
        if (buttons[i].type == type)
        {
          if (buttons[i].disabled != value)
          {
            buttons[i].disabled = value;
            this.setState({buttons:buttons});
          }
          break;
        }
      }
      
  }

  setDisabledButtonByKey(key, value)
  {
      var buttons = this.state.buttons;
      var nb = buttons.length;
      for (var i=0; i < nb ; i++)
      {
        if (buttons[i].key == key)
        {
          if (buttons[i].disabled != value)
          {
            buttons[i].disabled = value;
            this.setState({buttons:buttons});
          }
          break;
        }
      }
      
  }


  isButtonOkValid()
  {
    var buttons = this.state.buttons;
    var nb = buttons.length;
    for (var i=0; i < nb ; i++)
    {
      if (buttons[i].type == "ok")
        if (!buttons[i].disabled) return true;
    }
    return false;

  }

  
  
  render(body) {
   
    if (!this.props.display) return (<></>)


    // on calcul les boutons
    var buttons = [];
    for (var i=0; i < this.state.buttons.length; i++)
    {
      switch (this.state.buttons[i].type)
      {

        case "text":
          buttons.push(
            <Button 
              key={`button_${i}`}
            button={true}
            text={this.state.buttons[i].text}
            tooltip={null}
            disable={this.state.buttons[i].disabled}
            datas={this.state.buttons[i].key}
            onClick={this.handleButton}
            height={20}/>
            
          )
          buttons.push(<span key={`span_${i}`}>&nbsp;&nbsp;</span>);
          break;

        case "back":

          var text = {fr:"Retour",en:"Back"};
          if (this.state.buttons[i].text) text = this.state.buttons[i].text;



          buttons.push(
            <Button 
              key={`button_${i}`}
            button={true}
            image={imgBack} 
            tooltip={text} 
            disable={this.state.buttons[i].disabled}
            datas="back"
            onClick={this.handleButton}
            width={20} height={20}/>
            
          )
          buttons.push(<span key={`span_${i}`}>&nbsp;&nbsp;</span>);
          
          break;
        case "ok":
          buttons.push(
            <Button 
              key={`button_${i}`}
            button={true}
            image={imgValider}
            tooltip={{fr:"Valider la page",en:"Submit"}} 
            disable={this.state.buttons[i].disabled}
            datas="ok"
            onClick={this.handleButton}
            width={20} height={20}/>
            
          )
          buttons.push(<span key={`span_${i}`}>&nbsp;&nbsp;</span>);
          
        }
    }

    if (this.props.closebutton)
      var cb =
      (
        <div className="dialogTitleCloseButton">
        <Button tooltip={{fr:"Fermer",en:"Close"}} image={imgClose} width={18} height={18} onClick={this.onQuit}/>
        </div>
      )
      else
        cb = (<></>)



    return (
      <>
          <FullscreenOverlay>
            <div tabIndex={0} 
            onKeyDown={this.handleKeyDown}            
            className="dialogFullDiv">
          <div className="dialogInterneDiv" id={this.innerdiv} 
            style = {{
              left: this.state.x,
              top: this.state.y,
              zIndex: (this.props.zindex-1)*2+2,
              visibility:this.state.displayme,
            }} >


                  <div className="dialogTitle"
                      onMouseDown={this.handleMouseDown}                            
                    >
                    
                        <div className="dialogTitleText"

                            >
                            {this.context.language=="fr"?this.state.title.fr:this.state.title.en}
                        </div>
                        {cb}

                </div>

                {body}
                <div className="dialogButtonsDiv" >
                    {buttons}
                </div>
        </div>
        </div>
        </FullscreenOverlay>
      </>
    );
  }
}

Dialog.defaultProps = 
{
    zindex: 4,
    startposition: "center",
    closebutton: true,
}

export default Dialog;
